'use strict';

var _classCallCheck = require("/Volumes/Workstation/projects/mak-tender/MAK-TENDER-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Volumes/Workstation/projects/mak-tender/MAK-TENDER-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RandomStringBuilder = void 0;
var RandomStringBuilder = /*#__PURE__*/function () {
  /**
   * Create a new view config builder instance.
   */
  function RandomStringBuilder(config) {
    _classCallCheck(this, RandomStringBuilder);
    this.config = config;
  }
  /**
   * Assign the given `length` for the random string. By default, uses a length of 21 characters.
   *
   * @param length
   *
   * @returns {this}
   */
  _createClass(RandomStringBuilder, [{
    key: "length",
    value: function length(_length) {
      this.config.withLength(_length);
      return this;
    }
    /**
     * Use numbers when generating a random string.
     *
     * @returns {this}
     */
  }, {
    key: "characters",
    value: function characters() {
      this.config.useCharacters();
      return this;
    }
    /**
     * Use numbers when generating a random string.
     *
     * @returns {this}
     */
  }, {
    key: "numbers",
    value: function numbers() {
      this.config.useNumbers();
      return this;
    }
    /**
     * Use symbols when generating a random string.
     *
     * @returns {this}
     */
  }, {
    key: "symbols",
    value: function symbols() {
      this.config.useSymbols();
      return this;
    }
  }]);
  return RandomStringBuilder;
}();
exports.RandomStringBuilder = RandomStringBuilder;